<template>
  <v-dialog
    max-width="1000"
    persistent
    transition="dialog-bottom-transition"
    v-model="showDialog"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Create Showcase</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form">
        <v-card flat v-bind:loading="loading">
          <v-card-title>
            Properties
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field label="ID" v-model="showcaseId"> </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field label="Name" v-model="name"> </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="description"
                  label="Description"
                ></v-text-field>
              </v-col>
            </v-row>
            {{ message }}
          </v-card-text>
          <v-card-title>
            Url
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="5">
                <v-text-field label="Domain" v-model="domain"> </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  v-model="hostedZone"
                  :items="allowedHostedZones"
                  label="HostedZone"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="multiEnv" label="Enable MultiEnv"></v-switch>
              </v-col>
            </v-row>
            {{ message }}
          </v-card-text>
          <v-card-title>
            Select Showcase Image
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="6">
                <v-select
                  class="image-select"
                  v-model="showcaseSelect"
                  :items="listShowcases"
                  label="Showcase"
                  @change="setAvailableImages"
                >
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="selectedImage"
                  v-bind:items="availableImages"
                  class="image-select"
                  label="Image"
                >
                </v-select
              ></v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        {{ message }}
        <v-card-actions>
          <v-btn @click="runOperation()" :disabled="this.name === ''"
            >Run</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {
  LIST_SHOWCASES,
  CREATE_SHOWCASE,
  LIST_SHOWCASE_IMAGES
} from '@/domain/showcases/constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import { formatDate } from '@/domain/showcases/util/timeFormat'
export default {
  name: 'CreateShowcase',
  data: () => ({
    showDialog: true,
    loading: false,
    description: null,
    name: null,
    showcaseId: '',
    domain: '',
    hostedZone: null,
    allowedHostedZones: [
      { text: 'tts-cloud.com', value: 'tts-cloud.com' },
      { text: 'ttps.app', value: 'ttps.app' }
    ],
    availableImages: [],
    selectedImage: null,
    showcaseSelect: null,
    listShowcases: [],
    multiEnv: false,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null
  }),
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    }
  },
  methods: {
    setAvailableImages() {
      this.$apolloProvider.clients[DOMAIN_NAME].query({
        query: LIST_SHOWCASE_IMAGES,
        variables: {
          showcaseId: this.showcaseSelect
        },
        fetchPolicy: 'network-only'
      })
        .then(response => {
          this.availableImages = response.data.listImages
            .sort((a, b) => {
              return new Date(b.snapshotDate) - new Date(a.snapshotDate)
            })
            .map(image => {
              return {
                text: `${image.imageName} (${formatDate(image.snapshotDate)})`,
                value: image.imageName
              }
            })
        })
        .catch(err => (this.message = err))
    },
    runOperation() {
      this.$apolloProvider.clients[DOMAIN_NAME].mutate({
        mutation: CREATE_SHOWCASE,
        variables: {
          showcaseId: this.showcaseId,
          name: this.name,
          description: this.description,
          domain: this.domain,
          multiEnv: this.multiEnv,
          hostedZone: this.hostedZone,
          imageName: this.selectedImage
        },
        fetchPolicy: 'no-cache'
      })
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcases: {
      query: LIST_SHOWCASES,
      result({ data, loading, networkStatus }) {
        this.listShowcases = data.listShowcases.showcases.map(showcase => {
          return {
            text: `${showcase.name} (${showcase.showcaseId})`,
            value: showcase.showcaseId
          }
        })
      },
      error(error) {
        this.listShowcasesError = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped>
.image-select {
  width: 80%;
}
</style>
